import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { IAgronomyAgreementCropsContextValue } from './types';

export default createContext<IAgronomyAgreementCropsContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
